import { Injectable } from '@angular/core';
import { SessionData } from '../session-data';
import { SearchCriteria } from '../../car/shared/search-types';
import { ReservationDetail } from '../../car/shared/reservation-detail';
import { CarDetail } from '../../car/shared/car-detail';
import { Reservation } from '../../car/shared/reservation/reservation';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsDataService {

  public getCarBookingConfirmationData(reservationDetail: ReservationDetail, searchCriteria: SearchCriteria, searchResults: number): any {

    var result = {
      booking_date: new Date(),
      booking_step: "confirmation",
      car_booking_confirmation_id: reservationDetail.confirmationId,
      car_company_selected: reservationDetail.vehicle.companyName,
      car_type_selected: [reservationDetail.vehicle.carCategory],
      displayed_approximate_price: reservationDetail.vehicle.totalRate,
      dropoff_date: reservationDetail.dropOffDateTime,
      pickup_date: reservationDetail.pickupDateTime,
      search_dropoff_location: searchCriteria && (searchCriteria.hasDropOffLocation() ? searchCriteria.dropOff.location.locationName : searchCriteria.pickUp.location.locationName) || null,
      search_pickup_location: searchCriteria && searchCriteria.pickUp && searchCriteria.pickUp.location.locationName,
      search_dropoff_date: searchCriteria && searchCriteria.dropOff && searchCriteria.dropOff.date,
      search_pickup_date: searchCriteria && searchCriteria.pickUp && searchCriteria.pickUp.date,
      search_type: 'Car',
      search_results: searchResults,
      total_due: reservationDetail.pricingSummary.total
    };

    return result;
  }

  public getCarReservationData(searchCriteria: SearchCriteria, selectedCarDetail: CarDetail, searchResults: number, url: string): any {
    return {
      booking_step: "checkout",
      car_company_selected: selectedCarDetail.companyName,
      car_type_selected: [selectedCarDetail.carCategory],
      displayed_approximate_price: selectedCarDetail.totalRate.amount,
      dropoff_date: searchCriteria.dropOff.date,
      pickup_date: searchCriteria.pickUp.date,
      search_dropoff_location: searchCriteria.hasDropOffLocation() ? searchCriteria.dropOff.location.locationName : searchCriteria.pickUp.location.locationName,
      search_pickup_location: searchCriteria.pickUp.location.locationName,
      search_dropoff_date: searchCriteria.dropOff.date,
      search_pickup_date: searchCriteria.pickUp.date,
      search_type: 'Car',
      search_results: searchResults,
      total_due: selectedCarDetail.totalRate.amount,
      url: url
    };
  }

  public getCarReviewSelectionData(searchCriteria: SearchCriteria, selectedCarDetail: CarDetail, searchResults: number): any {
    return {
      booking_step: "detail",
      car_company_selected: selectedCarDetail.companyName,
      car_type_selected: [selectedCarDetail.carCategory],
      displayed_approximate_price: selectedCarDetail.totalRate,
      dropoff_date: searchCriteria.dropOff.date,
      pickup_date: searchCriteria.pickUp.date,
      search_dropoff_location: searchCriteria.hasDropOffLocation() ? searchCriteria.dropOff.location.locationName : searchCriteria.pickUp.location.locationName,
      search_pickup_location: searchCriteria.pickUp.location.locationName,
      search_dropoff_date: searchCriteria.dropOff.date,
      search_pickup_date: searchCriteria.pickUp.date,
      search_type: 'Car',
      search_results: searchResults,
      total_due: selectedCarDetail.totalRate
    };
  }

  public getCarSearcResultsData(searchCriteria: SearchCriteria, searchResults: number): any {
    return {
      booking_step: "search",
      search_dropoff_location: searchCriteria.hasDropOffLocation() ? searchCriteria.dropOff.location.locationName : searchCriteria.pickUp.location.locationName,
      search_pickup_location: searchCriteria.pickUp.location.locationName,
      search_dropoff_date: searchCriteria.dropOff.date,
      search_pickup_date: searchCriteria.pickUp.date,
      search_type: 'Car',
      search_results: searchResults
    };
  }

  public getCheckoutData(sessionData: SessionData, reservation: Reservation, searchCriteria: SearchCriteria, selectedCarDetail: CarDetail): any {
    let checkoutData = {
      startdate: searchCriteria.pickUp.date,
      enddate: searchCriteria.dropOff.date,
      destinationcity: searchCriteria.hasDropOffLocation() ? searchCriteria.dropOff.location.locationName : searchCriteria.pickUp.location.locationName,
      duration: selectedCarDetail.numberDays,
      lat: [selectedCarDetail.pickUpLocation.latitude, selectedCarDetail.returnLocation.latitude],
      long: [selectedCarDetail.pickUpLocation.longitude, selectedCarDetail.returnLocation.longitude],
      origination: sessionData.getPlatform(),
      locationname: selectedCarDetail.companyName,
      locationid: searchCriteria.pickUp.location.locationId,
      address: "CityName: " + selectedCarDetail.returnLocation.address.cityName + ", CountryCode : " + selectedCarDetail.returnLocation.address.countryCode + ", PostalCode : " + selectedCarDetail.returnLocation.address.postalCode + " AddressLine : " + selectedCarDetail.returnLocation.address.addressLine,
      quantity: 1,
      startlocation: selectedCarDetail.pickUpLocation.locationCode,
      endlocation: selectedCarDetail.returnLocation.locationCode,
      classofservice: selectedCarDetail.vehicleType
    };

    return checkoutData;
  }


  public getBookingCompletionData(sessionData: SessionData, searchCriteria: SearchCriteria, reservation: ReservationDetail, selectedCarDetail: CarDetail, bookingid: string): any {
    let bookingCompletionData = {
      startdate: new Date(reservation.pickupDateTime),
      enddate: new Date(reservation.dropOffDateTime),
      destinationcity: reservation.vehicle.returnLocation.locationName,
      duration: selectedCarDetail && selectedCarDetail.numberDays,
      lat: [],
      long: [],
      origination: sessionData.getPlatform(),
      locationname: reservation.vehicle.companyName,
      locationid: searchCriteria && searchCriteria.pickUp.location.locationId,
      address: "CityName: " + reservation.vehicle.returnLocation.address.cityName + ", CountryCode : " + reservation.vehicle.returnLocation.address.countryCode + ", PostalCode : " + reservation.vehicle.returnLocation.address.postalCode + " AddressLine : " + reservation.vehicle.returnLocation.address.addressLine,
      quantity: 1,
      bookingid: bookingid,
      startlocation: reservation.vehicle.pickUpLocation.locationCode,
      endlocation: reservation.vehicle.returnLocation.locationCode,
      classofservice: reservation.vehicle.vehicleType
    };

    if (selectedCarDetail && selectedCarDetail.pickUpLocation && selectedCarDetail.returnLocation) {
      bookingCompletionData.lat = [selectedCarDetail.pickUpLocation.latitude, selectedCarDetail.returnLocation.latitude];
      bookingCompletionData.long = [selectedCarDetail.pickUpLocation.longitude, selectedCarDetail.returnLocation.longitude];
    }

    return bookingCompletionData;
  }

  public getDestinationSearch(sessionData: SessionData, destinationSearch: any) {
    destinationSearch.origination = sessionData.getPlatform();

    return destinationSearch;
  }

  public getFailedData(sessionData: SessionData, error: any): any {
    let data = {
      errormessage: error.message,
      httperrorcode: error.status,
      bookingerror: null,
      origination: sessionData.getPlatform()
    };

    if (error.error && error.error.errors && error.error.errors.length > 0) {
      data.errormessage = error.error.errors[0].errorMessage;
    }

    return data;
  }

  public getBookingCompletionFailedData(sessionData: SessionData, error: any): any {
    let data = {
      errormessage: error.message,
      httperrorcode: error.status,
      bookingerror: error.message,
      origination: sessionData.getPlatform()
    };

    if (error.error && error.error.errors && error.error.errors.length > 0) {
      data.bookingerror = data.errormessage = error.error.errors[0].errorMessage;
    }

    return data;
  }

  public getProductDetailData(sessionData: SessionData, searchCriteria: SearchCriteria, selectedCarDetail: CarDetail): any {
    let productDetailData = {
      startdate: searchCriteria.pickUp.date,
      enddate: searchCriteria.dropOff.date,
      destinationcity: searchCriteria.hasDropOffLocation() ? searchCriteria.dropOff.location.locationName : searchCriteria.pickUp.location.locationName,
      duration: selectedCarDetail.numberDays,
      lat: [selectedCarDetail.pickUpLocation.latitude, selectedCarDetail.returnLocation.latitude],
      long: [selectedCarDetail.pickUpLocation.longitude, selectedCarDetail.returnLocation.longitude],
      origination: sessionData.getPlatform(),
      locationname: selectedCarDetail.companyName,
      locationid: searchCriteria.pickUp.location.locationId,
      address: "CityName: " + selectedCarDetail.returnLocation.address.cityName + ", CountryCode : " + selectedCarDetail.returnLocation.address.countryCode + ", PostalCode : " + selectedCarDetail.returnLocation.address.postalCode + " AddressLine : " + selectedCarDetail.returnLocation.address.addressLine,
      quantity: 1,
      startlocation: selectedCarDetail.pickUpLocation.locationCode,
      endlocation: selectedCarDetail.returnLocation.locationCode
    };

    return productDetailData;
  }
}
